export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14895.4a864982.jpg";